import { format } from 'date-fns'
import { Trans } from 'react-i18next'

interface WarnemContentProps {
  gracePeriod?: Date
}

export function WarnemContent({ gracePeriod }: WarnemContentProps) {
  const formattedDate = gracePeriod ? format(gracePeriod, 'MMMM d, yyyy') : ''

  return (
    <div>
      <p>
        <Trans i18nKey={'components.modals.paymentStatusWarnings.description'} />
      </p>
      {gracePeriod && (
        <p>
          <Trans
            i18nKey={'components.modals.paymentStatusWarnings.alternatively'}
            values={{ dueDate: formattedDate }}
          />
        </p>
      )}
      <p>
        <Trans
          i18nKey={'components.modals.paymentStatusWarnings.support'}
          components={{ a: <a href="mailto:support@marqii.com" /> }}
        />
      </p>
    </div>
  )
}
